<template>
    <v-autocomplete
        ref="reqSpecField"
        v-model="specField"
        :disabled="!req.filter.doc"
        color="teal"
        label="Specialization"
        :items="getReqSpecs"
        item-text="sp_name"
        auto-select-first
        return-object
        autocomplete="nope"
        @change="handleChangeReqSpecField($event)"
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['req'],
    data: ()=>({
        specField: null
    }),
    computed: {
        ...mapGetters(['getReqSpecs'])
    },
    watch: {
        getReqSpecs(newVal) {
            if (newVal) this.specField = newVal[0]
        },
        'req.specField': {
            handler(newVal) {
                this.specField = newVal
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(['reqDoctors']),
        handleChangeReqSpecField(value) {
            this.req.specField = value
            this.req.hospClinDoctor = ''
            this.req.hospClinType = 'H'
            this.req.hospClinDoctorCode = null
            this.req.decking = ''
            if (this.req.facility)
                this.reqDoctors({ PTYPE: '', HOSP_MSU: this.req.facility && this.req.facility.hosp_msu_code, SPEC: value && value.sp_desc })
        }
    }
}
</script>
